import React from "react";
import { cn } from "../../../common/u1/cn";
import { ClockIcon, CheckCircleIcon, AlertIcon } from "../../../../assets/ui/icons";
import { IN_PROGRESS, OPEN, EXPIRED } from "./purchasedState";

/* The pill on a purchased row — the single place a purchase state is drawn. */
/* Every glyph is given currentColor explicitly: CheckCircleIcon defaults to
   the owner-rail coral and both it and AlertIcon carry their own alignment
   class, neither of which belongs inside a pill. */
const STATES = {
  [IN_PROGRESS]: {
    label: "Report in progress",
    glyph: <ClockIcon size={13} className="shrink-0" />,
    className:
      "bg-[var(--warning-soft)] text-[var(--gold-deep)] border-[var(--gold-border)]",
  },
  [OPEN]: {
    label: "Open now",
    glyph: (
      <CheckCircleIcon
        size={13}
        stroke="currentColor"
        fill="transparent"
        className="shrink-0"
      />
    ),
    className:
      "bg-[var(--success-soft)] text-[var(--success)] border-[var(--verified-border)]",
  },
  [EXPIRED]: {
    label: "Access expired",
    glyph: <AlertIcon size={13} className="shrink-0" />,
    className: "bg-[var(--slate-2)] text-[var(--muted)] border-[var(--line)]",
  },
};

export const PurchaseBadge = ({ state = OPEN, daysLeft, className = "" }) => {
  const s = STATES[state] || STATES[OPEN];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 h-[26px] px-[11px] rounded-full border",
        "text-[12px] font-semibold tracking-[.01em] whitespace-nowrap font-sans",
        s.className,
        className
      )}
    >
      {s.glyph}
      {s.label}
      {/* Only an open purchase has a window to run out, and only when the row
          carries an expiry — the order-backed rows do not. */}
      {state === OPEN && typeof daysLeft === "number" && (
        <>
          <span aria-hidden="true" className="opacity-50">
            ·
          </span>
          <span>
            {daysLeft} {daysLeft === 1 ? "day" : "days"} left
          </span>
        </>
      )}
    </span>
  );
};

export default PurchaseBadge;
